import { createPersistedQueryLink as originalCreatePersistedQueryLink } from '@apollo/client/link/persisted-queries';
import {
  createPersistedQueryManifestVerificationLink,
  generatePersistedQueryIdsFromManifest,
  type PersistedQueryManifestForVerification,
} from '@apollo/persisted-query-lists';

export interface PersistedQueryManifest {
  operations: {
    id: string;
    name: string;
    type: string;
    body: string;
  }[];
}

const createPersistedQueryLink = ({
  isLocalDev,
  persistedQueryManifest,
}: {
  /**
   * when true, we will use only verify the persisted query but not use it
   * because it is not registered yet
   */
  isLocalDev?: boolean;
  persistedQueryManifest: PersistedQueryManifest;
}) =>
  isLocalDev
    ? createPersistedQueryManifestVerificationLink({
        // this link requires `operations.type` to be `'query' | 'subscription' | 'mutation'`, so casting is needed
        loadManifest: () =>
          persistedQueryManifest as PersistedQueryManifestForVerification,
        onVerificationFailed: (details) => {
          // eslint-disable-next-line no-console
          console.error(
            '[Persisted Query Manifest Error] %s: %s. Please regenerate manifest.',
            details.operation.operationName,
            details.reason
          );
        },
      })
    : originalCreatePersistedQueryLink({
        ...generatePersistedQueryIdsFromManifest({
          loadManifest: () => persistedQueryManifest,
        }),
        // Use GET method for queries. operationName is to be set as a query parameter
        // If we enable it for all queries there's a possibility of hitting the URL length limit
        // So we only enable it for hashed queries
        useGETForHashedQueries: true,
        disable: () => false,
      });

export { createPersistedQueryLink };
